export const UPDATE_SHARES = 'UPDATE_SHARES';

export const updateShares = shares => {
	return {
		type: UPDATE_SHARES,
		shares,
	};
};
